export default {
  // Common uses
  'buttonAdd': '添加',
  'buttonBrowse': '浏览',
  'buttonCancel': '取消',
  'buttonClear': '清除',
  'buttonDelete': '删除',
  'buttonDeleteData': '删除资料',
  'buttonDeleteWatermark': '删除水印',
  'buttonRemoveWatermark': '从显示中移除浮水印',
  'buttonOk': '确定',
  'buttonSave': '保存',
  'buttonSaveChanges': '保存更改',
  'buttonSubmitting': '提交中...',
  'buttonSubmitData': '提交资料',
  'confirmRemoveFunc': '确定删除该函数吗？',
  'labelCompanyName': '翱腾国际科技股份有限公司',
  'labelDataLoading': '加载中...',
  'labelDbData': '数据库资料',
  'labelHtmlFile': 'HTML 文件',
  'labelNoDbDataFound': '数据库中未找到资料',
  'labelRequired': '必填',
  'labelRequiredFields': '必填字段',
  'labelSearch': '搜索',
  'labelUrl': '网址',
  'notifAutoLoggedOut': '由于长时间未操作，您已被登出，请重新登录',
  'notifGetTokenError': '获取令牌错误',
  'placeholderEnter': '输入',
  "autoCreateKey":"未能自动插入新键",
  'refresh':'Refresh',
  // Login.vue
  'buttonLogin': '登录',
  'buttonCreateAccount': '创建账户',
  'labelCopyrightMessage': '保留所有权利',
  'labelCreateNewAcccount': '创建新账户',
  'labelDataRetrieveFail': '无法从服务器获取资料',
  'labelInitializing': '正在初始化...',
  'labelSignInMessage': '登录您的账户',
  'labelWelcomeMessage': 'OneConsole',
  'notifAccountAllInvalid': '输入不符合任何条件',
  'notifAccountStarnumInvalid': '星号太长，请保持在10-12位以内',
  'notifLoginError': `登录用户 'user_id' 失败。错误信息: error_message`,
  'notifLoginSuccess': `登录用户 'user_id' 成功`,
  'notifNoRolesAssigned': '该账户未分配角色！',
  'placeholderAccount': '输入您的账户',
  'placeholderPxd': '输入您的密码',
  'placeholderSelectCompanyID': '选择公司 ID',
  'notifErrorListDb': '调用 /listdb API 失败',
  'notifErrorLoadLanguage': '加载 language.db 失败',
  'notifErrorLoadSettings': '无法加载设置',
  'notifNoCidFound': '找不到公司 ID',
  // AppHeaderDropdownNotif.vue
  'labelNewNotification': '新',
  'labelNewNotificationMessage': '消息',
  'labelConfirmAction': '确认操作',
  'labelNoNotifications': '无通知',
  'titleAlertNotification': '警示通知',
  'titleInfoNotification': '信息通知',
  'titleOtherNotification': '其他通知',
  'titleWarningNotification': '警告通知',
  // AppHeaderDropdownAcct.vue
  'confirmLogout': '您确定要退出登录吗？',
  'labelSettings': '设置',
  'labelChangeCompanyId': '更改公司代码',
  'labelPluginManage': '管理插件',
  'labelPluginInstall': '安装插件',
  'labelGetAccount': '许可证',
  'labelChangePxd': '更改密码',
  'labelLogout': '退出登录',
  // AppSidebar.vue，IStoreSidebarNav.vue
  'labelAddNode': '添加节点',
  'labelAddPlugin': '添加插件',
  'labelAddRoot': '添加根目录',
  'labelEditNode': '编辑节点',
  'labelEditPlugin': '编辑插件',
  'labelEditRoot': '编辑根目录',
  'labelRemoveNode': '删除节点',
  'labelRemovePlugin': '删除插件',
  'labelRemoveRoot': '删除根目录',
  // DefaultLayout.vue
  'notifRemoveNodeError': '节点删除错误！',
  'notifRemoveNodeSuccess': '成功删除节点',
  'notifRemovePluginError': '插件删除错误！',
  'notifRemovePluginSuccess': '成功删除插件',
  'notifRemoveRootError': '根目录删除错误！',
  'notifRemoveRootSuccess': '成功删除根目录',
  // FunctionCreator.vue, FunctionEditor.vue
  'buttonAddField': '添加字段',
  'labelAddOneField': `请在点击 'which_button' 提交之前至少再新增一个字段`,
  'labelDatabase': '数据库',
  'labelDisabled': '停用',
  'labelDisplayName': '显示名称',
  'labelModule': '模块',
  'labelName': '名称',
  'labelOrder': '排序',
  'labelParent': '路径',
  'labelRequiredDisplayName': '请输入显示名称',
  'labelRequiredKey': '请输入数据库键',
  'labelRequiredModule': '请输入模块',
  'labelRequiredName': '请输入名称',
  'labelType': '存储类型',
  'notifAddNodeSuccess': '新节点添加成功',
  'notifAddNodeError': '新增节点失败',
  'notifHideNodeSuccess': '隐藏节点成功',
  'optionCustom': '自定义',
  'optionJson': 'JSON',
  'optionPath': '路径',
  'optionUrl': 'URL',
  'placeholderDisplayName': '输入显示名称',
  'placeholderField': '输入字段名称',
  'placeholderKey': '输入数据库键',
  'placeholderModule': '输入模块',
  'placeholderName': '输入名称',
  'placeholderNameTable': '自动填写由',
  'placeholderOrder': '输入排序',
  'titleAddNode': '添加节点',
  'titleEditNode': '编辑节点',
  'titleTableFieldName': '字段名称',
  'titleTableFieldType': '字段类型',
  'titleTableFormat': '格式',
  'titleTableInRow': '在行中',
  'titleTableInSearch': '在搜索中',
  'titleTableRequired': '必填',
  'titleTableRemove': '移除',
  // CreateNewData.vue, DataViewer.vue, DataEditor.vue
  'confirmDataDelete': '您确定要删除您的资料吗？',
  'labelDataFound': '找到资料',
  'labelDisplayRows': '显示行',
  'labelEntries': '条目',
  'labelNoDataFound': `在 item_database 数据库中未找到资料`,
  'labelNoDataFoundSearch': `在 item_database 数据库中未找到以 search_term 搜索关键字的资料`,
  'labelSelected': '已选择',
  'labelOf': '共',
  'labelRows': '行',
  'labelRequiredDate': '请设置日期',
  'labelRequiredEmail': '请输入电子邮件',
  'labelRequiredNumber': '请输入数字',
  'labelRequiredString': '请输入资料',
  'labelSearchBy': '搜索',
  'labelShowing': '显示中',
  'labelTotalData': '总资料',
  'notifAddDataError': '新增资料失败',
  'notifAddDataSuccess': '资料新增成功',
  'notifDataEditError': '资料修改失败',
  'notifDataEditSuccess': '资料编辑成功',
  'notifDataDeleteError': '删除资料失败',
  'notifDataDeleteSuccess': '资料删除成功',
  'notifEditNodeError': '无法编辑节点',
  'notifEditNodeSuccess': '编辑节点成功',
  'notifKeyNotFound': '未找到键值',
  'notifJsonEditError': '解析资料失败，请重新检查您的编辑',
  'notifPropertiesEditError': '属性字符串格式错误，请重新检查您的编辑',
  'placeholderAddDbKey': '数据库密钥（自动填写）',
  'titleAddDataModal': '新增资料',
  'titleEditDataModal': '编辑资料',
  'tooltipAddDataButton': '添加数据',
  'tooltipDeleteDataButton': '删除数据',
  'tooltipExportDataButton': '导出数据',
  'tooltipImportDataButton': '导入数据',
  'tooltipShowCheckboxButton': '显示复选框（选择数据）',
  // ImportExportModal.vue
  'labelChooseOneOfColumns': '选择一列',
  'labelExportAs': '导出为',
  'labelSelectAll': '全选',
  'labelChooseColumnsToExport': '选择要导出的列',
  'labelChooseColumnsToImport': '选择要导入的列',
  'notifImportDataSuccess': '数据导入成功',
  'notifImportDataError': '导入数据错误',
  'notifInvalidCsv': '无效的 CSV 文件',
  'placeholderExportFilename': '导出文件名',
  'titleExportDataModal': '导出数据',
  'titleImportDataModal': '导入数据',
  // AccountCreator.vue, AccountEditor.vue
  'buttonAddUser': '添加用户',
  'buttonEditUser': '编辑用户',
  'buttonRemoveUser': '移除用户',
  'labelActions': '操作',
  'labelActivated': '已启用',
  'labelActivatedDate': '启用日期',
  'labelDateEmpty': '请输入日期',
  'labelEmail': '电子邮件',
  'labelInvalidEmailFmt': '电子邮件格式无效，请输入类似: test@mail.com',
  'labelLanguage': '语言',
  'labelPxd': '密码',
  'labelSuspend': '暂停',
  'labelUserId': '用户 ID',
  'labelUserName': '用户名',
  'labelUserStatus': '用户状态',
  'labelRole': '角色',
  'labelCid': '公司 ID',
  'labelDepartment' : "部门",
  'notifAddUserError': '注册用户时发生错误！',
  'notifAddUserSuccess': '用户注册成功',
  'notifDifferentUidEmail': '用户 ID 和电子邮件不一致！',
  'notifDuplicateData': '该用户 ID 已被其他用户使用！',
  'notifModifyUserError': '编辑用户资料时发生错误！',
  'notifModifyUserSuccess': '成功编辑用户资料',
  'notifNoWhiteSpcUid': '用户 ID 中不允许有空格！',
  'notifSetActivatedDate': '请设置\'启用日期\'！',
  'placeholderEmail': '输入电子邮件',
  'placeholderUserId': '输入您的用户账号',
  'placeholderUserName': '输入您的用户名',
  'titleAddNewUser': '新增用户',
  'titleEditUserData': '编辑用户资料',
  'titleShowPxd': '点击显示密码',
  'notifCopyPxd': '密码已复制到剪贴板！',
  'labelResetPxd': '重置密码',
  'notifChooseCid': '请选择公司 ID',
  'system.accountManager.column.userName': '用户名',
  'system.accountManager.column.roleNames': '角色',
  // ChangePxd.vue
  'labelConfirmNewPxd': '确认新密码',
  'labelCurrentPxd': '当前密码',
  'labelNewPxd': '新密码',
  'placeholderConfirmNewPxd': '重新输入新密码',
  'placeholderCurrentPxd': '输入当前密码',
  'placeholderNewPxd': '输入新密码',
  'notifChangePxdError': '密码修改失败',
  'notifChangePxdSuccess': '密码修改成功',
  'titleChangePxd': '修改密码',
  'notifPxdIncorrect': '密码不正确！',
  'notifPxdInvalid': '密码格式无效！',
  'notifPxdNotFound': '未找到密码！',
  'notifPxdRecheck': '请重新检查新密码！',
  // PluginManager.vue
  'titlePluginManage': '管理插件',
  'buttonPluginUpdate': '更新插件',
  'buttonPluginInstall': '安装插件',
  'buttonExcludePlugin': '排除',
  'buttonIncludePlugin': '包括',
  'notifInstallPluginSuccess':'插件安装成功！',
  'notifDataNeed2BeSelected':'至少需要选择 1 个插件',
  'labelInstallPlugin':'添加新插件',
  // GetAccount.vue
  'titleGetAcc':'许可证',
  'labelSerialNumber':'验证码',
  'placeholderSerialNumber':'输入验证码',
  'labelIPAddr':'外部 IP 地址',
  'placeholderIPAddr':'输入外部 IP 地址',
  'labelMACAddr':'网卡 MAC 地址',
  'placeholderMACAddr':'输入网卡 MAC 地址',
  'labelProvisioning':'配置中...',
  // RoleCreator.vue, RoleEditor.vue
  'labelRoleName': '角色名称',
  'labelRoleId': '角色编号',
  'labelLevelId': '角色层级',
  'labelFunctionsToAssign': '分配功能',
  'titleAddRoleModal': '定义新角色',
  'titleEditRoleModal': '编辑角色',
  // BackupServerCreator.vue, BackupServerEditor.vue
  'labelCompanyId': '公司 ID',
  'labelCompanyIdExists': '公司 ID 已存在',
  'labelEncrypt': '加密',
  'labelFileUrl': '文件 URL',
  'labelImAddress': 'IM 地址',
  'labelIndexServers': '索引服务器',
  'labelPushServicePort': '推送服务端口',
  'labelPushServicePortal': '推送服务门户',
  'labelStarNumberType': '星号类型',
  'labelStarVPort': 'StarV 端口',
  'notifAddServerBackupError': '添加备份服务器配置失败！',
  'notifAddServerBackupSuccess': '成功添加备份服务器配置',
  'notifEditServerBackupError': '编辑备份服务器配置失败！',
  'notifEditServerBackupSuccess': '成功编辑备份服务器配置',
  'notifCheckRequiredData': '检查必填数据是否为空',
  'notifDuplicateCompanyId': '公司 ID 已存在！请使用其他公司 ID',
  'placeholderCompanyId': '输入公司 ID',
  'placeholderFileUrl': '输入文件 URL',
  'placeholderIMAddr': '输入 IM 地址',
  'placeholderINode': '输入 iNode 配置',
  'placeholderIp': '输入 IP 配置',
  'placeholderPushServicePort': '输入推送服务端口',
  'placeholderPushServicePortal': '输入推送服务门户',
  'placeholderStarNumberType': '输入星号类型',
  'placeholderStarVPort': '输入 StarV 端口',
  'titleAddBackupServer': '定义新的备份服务器',
  'titleEditBackupServer': '编辑备份服务器',
  // Page404.vue
  'labelPage404Message': '找不到您正在寻找的页面',
  'titlePage404': '对不起',
  // WatermarkSetting.vue
  'confirmWatermarkDelete': '您确定要删除此水印吗？',
  'labelAddNewWatermark': '添加新水印',
  'labelNoWatermark': '无水印',
  'labelSelectWatermark': '选择水印',
  'labelWatermarkFile': '水印文件',
  'labelWatermarkName': '水印名称',
  'labelWatermarkPreview': '预览',
  'labelWatermarkSetting': '水印设置',
  'notifAddWatermarkError': '添加新水印失败！',
  'notifAddWatermarkSuccess': '成功添加新水印',
  'notifDeleteWatermarkError': '无法删除 \'watermark_name\' 水印！',
  'notifDeleteWatermarkSuccess': '成功删除 \'watermark_name\' 水印',
  'notifSetWatermarkError': '无法设置水印！',
  'notifSetWatermarkSuccess': '水印设置成功',
  'placeholderWatermarkFile': '上传水印文件',
  'placeholderWatermarkName': '输入水印名称',
  'placeholderWatermarkSelect': '选择水印',
  'titleWatermarkSetting': '水印设置',
  // DepartmentManager.vue
  "titleAddDepartmentModal": "新增部门",
  "titleEditDepartmentModal": "编辑部门",
  "system.departmentManager.column.departmentName": "部门名称",
  "system.departmentManager.column.departmentDescription": "部门描述",
  "system.departmentManager.column.users": "使用者",
  "system.departmentManager.column.roles": "角色",
  // LanguageCreator.vue, LanguageEditor.vue
  'labelLangKey': 'KEY',
  'labelEnglish': '英文',
  'labelTaiwanese': '中文（繁体）',
  'labelChinese': '中文（简体）',
  'labelJapanese': '日文',
  "titleAddLanguageData": "新增语言资料",
  "titleEditLanguageData": "编辑语言资料",
  // PluginInstaller.vue
  "labelPluginName":"插件名称",
  'notifAddBinSuccess': '二进制文件上传成功',
  'notifSetBinError': '二进制文件上传失败！',
  // ApiManager.vue
  'system.apiManager':'API Manager'
}
